'use client';
import { MapProps } from '@/app/_components/widgets/map/interactive';
import dynamic from 'next/dynamic';
import { useRef, useState, useEffect } from 'react';

const DynamicMap = dynamic(() => import('@/app/_components/widgets/map/interactive'), {
  ssr: false,
  loading: () => null,
});

const MapStaticToInteractive = ({
  items,
  markerLabelType,
  setUserGeolocation,
  isUserGeolocationActive,
  hoveredCardId,
  viewOverride,
  onMapViewportChanged,
  onMarkerFocusChanged,
  onPopupBookCtaClicked,
  onPopupOpened,
  onViewOverrideApplied,
}: MapProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setIsInView(true);
          io.disconnect();
        }
      },
      { rootMargin: '400px 0px' }, // pre-carica un po' prima
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  if (!isInView) {
    return <div ref={ref} />;
  }

  return (
    <DynamicMap
      items={items}
      markerLabelType={markerLabelType}
      setUserGeolocation={setUserGeolocation}
      isUserGeolocationActive={isUserGeolocationActive}
      hoveredCardId={hoveredCardId}
      viewOverride={viewOverride}
      onMapViewportChanged={onMapViewportChanged}
      onMarkerFocusChanged={onMarkerFocusChanged}
      onPopupBookCtaClicked={onPopupBookCtaClicked}
      onPopupOpened={onPopupOpened}
      onViewOverrideApplied={onViewOverrideApplied}
    />
  );
};

export default MapStaticToInteractive;
